import { ShirtspaceResponseMessage } from "@services/ShirtspaceService/ShirtspaceService.types";
import { forwardRef } from "react";
import FieldError from "./FieldError";

type Props = {
  label: string;
  name: string;
  ariaLabel?: string;
  placeholder?: string;
  error?: ShirtspaceResponseMessage;
};

const Field = forwardRef<HTMLInputElement, Props>(
  ({ label, name, placeholder, error, ariaLabel }, ref) => {
    return (
      <div className="flex flex-col gap-0.5">
        <label
          className="text-sm leading-none text-blue900"
          htmlFor={name}
        >
          {label}
          <span className="text-red200"> *</span>
        </label>
        <input
          aria-label={ariaLabel}
          ref={ref}
          id={name}
          name={name}
          className={`h-8 p-2 rounded border ${error ? "border-red200" : "border-black"}`}
          type="text"
          placeholder={placeholder}
        />
        <FieldError fieldError={error} />
      </div>
    );
  },
);

Field.displayName = "Field";

export default Field;
